module.exports = __webpack_public_path__ + "img/testimonial-expert.f6725c43.jpg";